import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface IdentityProvider {
  id: string;
  name: string;
  type: string;
  status: string;
  created_at: string;
  updated_at: string;
}

export const useIdentityProviders = () => {
  return useQuery({
    queryKey: ['identity_providers'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('identity_providers')
        .select('*')
        .eq('status', 'connected')
        .order('name');
      
      if (error) throw error;
      return data as IdentityProvider[];
    }
  });
};
